// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase"
const firebaseConfig = {
    apiKey: "AIzaSyDHFCQCbxP-KxQ0Rq_7rj6OFQjNjG8lAXM",
    authDomain: "linkedin-clone-fcfc0.firebaseapp.com",
    projectId: "linkedin-clone-fcfc0",
    storageBucket: "linkedin-clone-fcfc0.appspot.com",
    messagingSenderId: "350753818812",
    appId: "1:350753818812:web:ead30eabd7e21faaee68b9",
    measurementId: "G-75C11NG5K1"
  };
  const firebaseApp=firebase.initializeApp(firebaseConfig)
  const db=firebaseApp.firestore();
  const auth=firebase.auth();
  export {db,auth};